import * as Effect from "effect/Effect";
import * as Schema from "effect/Schema";
import * as SchemaTransformation from "effect/SchemaTransformation";
export const TrimmedString = Schema.String.pipe(Schema.decodeTo(Schema.String, SchemaTransformation.transformOrFail({
    decode: (value) => Effect.succeed(value.trim()),
    encode: (value) => Effect.succeed(value.trim()),
})));
export const TrimmedNonEmptyString = TrimmedString.check(Schema.isNonEmpty());
export const NonNegativeInt = Schema.Int.check(Schema.isGreaterThanOrEqualTo(0));
export const PositiveInt = Schema.Int.check(Schema.isGreaterThanOrEqualTo(1));
export const PortSchema = Schema.Int.check(Schema.isBetween({ minimum: 1, maximum: 65535 }));
export const IsoDateTime = Schema.String;
/**
 * Construct a branded identifier. Enforces non-empty trimmed strings
 */
const makeEntityId = (brand) => {
    return TrimmedNonEmptyString.pipe(Schema.brand(brand));
};
/**
 * A thread id doubles as an on-disk directory name (`attachments/<id>/`) and a
 * URL segment, so the type itself carries the filesystem-safe shape: lowercase
 * alphanumerics with inner `-`/`_`, at most 80 characters, never starting or
 * ending with a separator. Every generator mints ids inside this alphabet
 * (`randomUUID()`, `deriveSubAgentThreadId`), and the check makes that a
 * boundary guarantee instead of a convention: a traversal- or Windows-hostile
 * id cannot be constructed or decoded anywhere.
 */
export const ThreadId = TrimmedNonEmptyString.check(Schema.isPattern(/^[a-z0-9](?:[a-z0-9_-]{0,78}[a-z0-9])?$/)).pipe(Schema.brand("ThreadId"));
export const ProjectId = makeEntityId("ProjectId");
export const EnvironmentId = makeEntityId("EnvironmentId");
export const CommandId = makeEntityId("CommandId");
export const EventId = makeEntityId("EventId");
export const MessageId = makeEntityId("MessageId");
export const TurnId = makeEntityId("TurnId");
export const AuthSessionId = makeEntityId("AuthSessionId");
export const ProviderItemId = makeEntityId("ProviderItemId");
export const RuntimeSessionId = makeEntityId("RuntimeSessionId");
export const RuntimeItemId = makeEntityId("RuntimeItemId");
export const RuntimeTaskId = makeEntityId("RuntimeTaskId");
